module.exports = {"name":"@dialogexe/cw-component-card","version":"1.1.3","description":"DX CustomWeb Card Component","main":"Card.tsx","scripts":{},"repository":{"type":"git","url":"git+https://github.com/dialogexe/cw-component-card.git"},"keywords":["card"],"author":"DX","license":"ISC","bugs":{"url":"https://github.com/dialogexe/cw-component-card/issues"},"homepage":"https://github.com/dialogexe/cw-component-card#readme","peerDependencies":{"react":"^16.3.2"},"publishConfig":{"registry":"https://npm.pkg.github.com/"}}


//////////////////
// WEBPACK FOOTER
// ./~/@dialogexe/cw-component-card/package.json
// module id = 989
// module chunks = 178422501501999